// Must be the first import
import { h, render } from "preact";
import "preact/debug";
// This is a file where we connect react components
import "./js/slider.jsx";

import {services } from "./js/calculators/simple-service/data"

import {IPriceTable, SimpleService} from "./js/calculators/simple-service/types.js"
import { onDOMLoad, onLoad } from "./js/utils";
import { sleep } from "./js/tools";


async function calculator() {
  let container = document.querySelector(".pult-calculator");
  if (!container) return;

  let { Calculator } = await import(
    /* webpackChunkName: "kitCalculator" */ 
    "./js/calculators/tools/"
  );
  let type = container.getAttribute("data-type");

  // Clear content before mounting
  container.innerHTML = "";
  // Init the widget
  // @ts-ignore
  render(<Calculator type={type} />, container);
}

async function InitSecurityCalculator() {
  let container = document.querySelector(".security-calculator-widget");
  if (!container) return;

  let { SecurityCalculator } = await import(
    /* webpackChunkName: "securityCalc" */ "./js/calculators/security/"
  );

  let type = container.getAttribute("data-type");

  // Init the widget
  // Clear content before mounting
  container.innerHTML = "";
  render(<SecurityCalculator type={type} />, container, );
}



async function SVGMapInit() {
  let container = document.querySelector(".svg-map-widget");
  if (!container) return;

  let { SVGMap } = await import(
    /* webpackChunkName: "SVGMap" */ 
    "./js/svgmap/"
  );
  SVGMap(container)
}

async function ServicesPage() {
  // let container = document.querySelector(".services-index");
  // if (!container) return;

  // let { SVGMap } = await import(
  //   /* webpackChunkName: "securityCalc" */ "./js/svgmap/"
  // );
  // render(<SVGMap />, container);
}

async function InitServiceCalculators() {
  let containers = document.querySelectorAll(".calc-simple-service");
  if (containers.length == 0) return;

  let { ServiceCalculator } = await import(
    /* webpackChunkName: "SimpleServiceCalculator" */ 
    "./js/calculators/simple-service/"
  );

  containers.forEach(async (container)=> {
    let type = container.getAttribute("data-type");

    let services: SimpleService[] = [];
    let SingleSetupCost = 0;
    let PriceTable: IPriceTable = [];
    let TableTitle = ""
    let stuff = await import( /* webpackChunkName: "[request]" */ "./js/calculators/simple-service/data/" + type );
    
  
    if (stuff != null) {
      services = stuff.services
      SingleSetupCost = stuff.SingleSetupCost 
      PriceTable = stuff.PriceTable
      TableTitle = stuff.TableTitle
    }
    
    // Render the thing
    if (SingleSetupCost > 0 && services.length > 0) {
      // Clear content before mounting
      container.innerHTML = "";
      render(<ServiceCalculator oneSetupCost={SingleSetupCost} services={services} pricingTable={PriceTable} title={TableTitle}/>, container);
    }
  })

  
  
}


async function LoadLottieAnimations(){
  // wait 2 seconds before trying to load it
  // 
  console.log("waiting")
  await sleep(500);
  let { lottieAnimation } = await import( /* webpackChunkName: "HeaderLottieAnimations" */ "./js/lottie" );
  console.log("loaded")
  lottieAnimation();
}


onDOMLoad(() => {
  InitServiceCalculators();
  InitSecurityCalculator();
  calculator();
  SVGMapInit();
  // ServicesPage();
 

});

onLoad(()=>{
  LoadLottieAnimations();
  
})